"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ClaimDocuments {
    constructor({ commercialInvoice, consignmentNote, deliveryReceipts, inlandBillOfLading, photos, packingList, policeReport, fireReport, reeferTempLog, seaWaybill, copyLetterToCarrier, vesselsOutturnReport, containerDamageReport, interchangeReceipt, mastersStatementOfFacts, preshipmentSurveys, forPerishableGoods, condemnationCertificates, shipsTemperatureLog, certificateOrOrigin, railwayBillOfLading, multimodalBillOfLading, fiataMultimodalBillOfLading, cimSmgsConsignmentNote, freightInvoice }) {
        this.commercialInvoice = commercialInvoice;
        this.consignmentNote = consignmentNote;
        this.deliveryReceipts = deliveryReceipts;
        this.inlandBillOfLading = inlandBillOfLading;
        this.photos = photos;
        this.packingList = packingList;
        this.policeReport = policeReport;
        this.fireReport = fireReport;
        this.reeferTempLog = reeferTempLog;
        this.seaWaybill = seaWaybill;
        this.copyLetterToCarrier = copyLetterToCarrier;
        this.vesselsOutturnReport = vesselsOutturnReport;
        this.containerDamageReport = containerDamageReport;
        this.interchangeReceipt = interchangeReceipt;
        this.mastersStatementOfFacts = mastersStatementOfFacts;
        this.preshipmentSurveys = preshipmentSurveys;
        this.forPerishableGoods = forPerishableGoods;
        this.condemnationCertificates = condemnationCertificates;
        this.shipsTemperatureLog = shipsTemperatureLog;
        this.certificateOrOrigin = certificateOrOrigin;
        this.railwayBillOfLading = railwayBillOfLading;
        this.multimodalBillOfLading = multimodalBillOfLading;
        this.fiataMultimodalBillOfLading = fiataMultimodalBillOfLading;
        this.cimSmgsConsignmentNote = cimSmgsConsignmentNote;
        this.freightInvoice = freightInvoice;
    }
    static fromObj(data = {}) {
        return new ClaimDocuments(data);
    }
}
exports.default = ClaimDocuments;
//# sourceMappingURL=claimDocuments.class.js.map